module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/83dd62c9b8fe57c2593672212bc09951.png";